/* eslint-disable @typescript-eslint/default-param-last */
import { createAction, createSelector } from "@reduxjs/toolkit";
import { presetStateSelector } from "../utils/state.js";
export const toggleHistory = createAction("chat/toggleHistory");
export const toggleChat = createAction("chat/collapseChat");
export const changeChatId = createAction("chat/changeChatId");
export const assistantChange = createAction("history/assistantChange");
const initialState = {
    chatId: 0,
    chatOpen: true,
    historyOpen: true,
};
/**
 * Slim chat reducer — chat data now lives in ChatSubscriptionStore
 * via useSyncExternalStore. This reducer only holds UI state.
 */
export const assistantReducer = (state = initialState, action) => {
    switch (action.type) {
        case toggleHistory.type: {
            return {
                ...state,
                historyOpen: !state.historyOpen,
            };
        }
        case toggleChat.type: {
            return {
                ...state,
                historyOpen: !state.historyOpen,
                chatOpen: !state.chatOpen,
            };
        }
        case changeChatId.type: {
            const { payload, } = action;
            return {
                ...state,
                chatId: payload.id,
            };
        }
        default:
            return state;
    }
};
export const getAIChatState = createSelector([presetStateSelector], state => state.chat);
export const getChatId = createSelector([getAIChatState], aiChat => aiChat.chatId);
export const getAIChatHistoryOpen = createSelector([getAIChatState], aiChat => aiChat.historyOpen);
export const getAIChatOpen = createSelector([getAIChatState], aiChat => aiChat.chatOpen);
